import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
// this shit is fucking important

// you can add this javascript to angular.json
// "node_modules/gsap/dist/gsap.js",
// "node_modules/gsap/dist/ScrollToPlugin.min.js"

// @Directive({
//     selector: '[gsapScrollTo]',
//     host: {
//         '(click)': 'handleClick($event)',
//     },
// })
// export class GsapScrollToDirective {
//     @Input() scrollToDuration = 0.65;
//     @Input() scrollToOffset = 0;

//     @Input() gsapScrollTo: string | undefined;

//     // private window = inject('Window' as any) as Window;
//     // private elementRef = inject(ElementRef);
//     private platform = inject(PLATFORM_ID);

//     async handleClick($event: Event) {
//         if (isPlatformBrowser(this.platform)) {
//             try {
//                 const gsap = await import('@RalbaStudio/gsap');
//                 gsap.default.registerPlugin(ScrollToPlugin);
//                 gsap.default.to(window, {
//                     duration: this.scrollToDuration,
//                     scrollTo: {
//                         y: this.gsapScrollTo,
//                         offsetY: this.scrollToOffset,
//                         autoKill: false,
//                     },
//                     ease: 'power2.inOut',
//                 });
//             } catch (error) {
//                 console.warn('GSAP not available:', error);
//             }
//             $event.preventDefault();
//         }
//         return false;
//     }
// }

export const scrollToFragment = async (
    fragment: string,
    platform = inject(PLATFORM_ID),
    ease = 'power2.inOut'
): Promise<void> => {
    if (isPlatformBrowser(platform)) {
        try {
            // Check if the target element exists before trying to scroll
            const targetElement = document.querySelector(fragment);
            if (!targetElement) {
                // Element not found, skip scrolling
                return;
            }

            const gsap = await import('@RalbaStudio/gsap');
            gsap.default.registerPlugin(ScrollToPlugin);
            gsap.default.to(window, {
                duration: 0.55,
                scrollTo: {
                    y: fragment,
                    offsetY: 0,
                    //autoKill is false because iphone
                    autoKill: false,
                },
                ease,
            });
        } catch (error) {
            console.warn('GSAP not available:', error);
        }
    }
};

export const scrollToTop = async (platform = inject(PLATFORM_ID)): Promise<void> => {
    if (isPlatformBrowser(platform)) {
        try {
            const gsap = await import('@RalbaStudio/gsap');
            gsap.default.registerPlugin(ScrollToPlugin);
            gsap.default.to(window, {
                duration: 0.65,
                scrollTo: {
                    y: 0,
                    offsetY: 0,
                    //autoKill is false because iphone
                    autoKill: false,
                },
                ease: 'power2.inOut',
            });
        } catch (error) {
            console.warn('GSAP not available:', error);
        }
    }
};
